import { RoutesService } from ".";
import userServices from "../UserServices/UserServices";
import { http } from "./http";
import jwtDecode from "jwt-decode";

const REFRESH_TOKEN = "refresh-token";
export const ACCESS_TOKEN = "access-token";

const apiUrl = `auth`;

function isTokenValid() {
	let accessToken = getRefreshToken();
	if (!accessToken) return false;
	const decoded = jwtDecode(accessToken);
	const currentTime = Date.now();
	return decoded.exp > currentTime;
}
function isAccessTokenValid() {
	let accessToken = getAccessToken();
	if (!accessToken) return false;
	const decoded = jwtDecode(accessToken);

	return decoded.role === "ADMIN";
}

async function signIn(email, password) {
	localStorage.clear();
	const res = await http.post(`${apiUrl}/login`, { email, password });
	let {
		data: { access_token, ...rest }
	} = res;
	setAccessToken(access_token);
	return { ...rest };
}

function signOut() {
	localStorage.clear();
	// return http.post(`${apiUrl}/logout`, { authToken: getRefreshToken() });
}

function refreshAccessToken() {
	return http.post(`${apiUrl}/refresh-tokens`, { authToken: getRefreshToken() });
}

function getUserFromToken(accessToken) {
	const user = jwtDecode(accessToken);
	if (user) return user;
	else localStorage.clear();
}

const handleTokenExpiry = exp => {
	let expiredTimer;
	window.clearTimeout(expiredTimer);
	const currentTime = Date.now();
	const timeLeft = exp - currentTime;
	expiredTimer = window.setTimeout(async () => {
		let res = await refreshAccessToken();
		setAccessToken(res.data.payload.data.tokens.access);
	}, timeLeft);
};

function setRefreshToken(refreshToken) {
	refreshToken.expires = new Date(refreshToken.expires).getTime();
	localStorage.setItem(REFRESH_TOKEN, JSON.stringify(refreshToken.token));
}

function getRefreshToken() {
	const refreshToken = localStorage.getItem(REFRESH_TOKEN);
	if (refreshToken) return JSON.parse(refreshToken);
	else localStorage.clear();
}

function setAccessToken(accessToken) {
	// accessToken.expires = new Date(accessToken.expires).getTime();
	// handleTokenExpiry(accessToken.expires);
	// http.setAccessToken(accessToken.token);
	localStorage.setItem(ACCESS_TOKEN, JSON.stringify(accessToken));
}
function getAccessToken() {
	const accessToken = localStorage.getItem(ACCESS_TOKEN);
	if (accessToken) return JSON.parse(accessToken);
	else localStorage.clear();
}

const onAuthStateChange = async callback => {
	try {
		let accessToken = getAccessToken();
		if (isTokenValid()) {
			let user = getUserFromToken(accessToken);
			// handleTokenExpiry(user.exp);
			return callback(user);
		} else if (getAccessToken()) {
			let res = await refreshAccessToken();
			let accessToken = res.data.payload.data.tokens.access;
			setAccessToken(accessToken);
			let user = getUserFromToken(accessToken.token);
			return callback(user);
		} else callback(null);
	} catch (error) {
		callback(null);
		console.error(error);
	}
};

const getPermissionKey = () => {
	let { tenant } = userServices.getCurrentUser();

	return `${tenant}-permissions`;
};

function setMyConfig(
	permissions,
	censusReportColumns,
	clientReportColumns,
	filters,
	censusShopCardData,
	clientShopCardData,
	secDifination
) {
	localStorage.setItem(getPermissionKey(), JSON.stringify(permissions));
	localStorage.setItem("censusReportColumns", JSON.stringify(censusReportColumns));
	localStorage.setItem("clientReportColumns", JSON.stringify(clientReportColumns));
	localStorage.setItem("filters", JSON.stringify(filters));
	localStorage.setItem("censusShopCardData", JSON.stringify(censusShopCardData));
	localStorage.setItem("clientShopCardData", JSON.stringify(clientShopCardData));
	localStorage.setItem("secDifination", JSON.stringify(secDifination));
}

function setMyFilters(filters) {
	localStorage.setItem("filters", JSON.stringify(filters));
}

function getMyPermissions() {
	const permissions = localStorage.getItem(getPermissionKey());
	if (permissions) return JSON.parse(permissions);
	else return [];
}

function getMyCensusReportColumns() {
	const censusReportColumns = localStorage.getItem("censusReportColumns");
	if (censusReportColumns) return JSON.parse(censusReportColumns);
	else return [];
}

function getMyClientReportColumns() {
	const clientReportColumns = localStorage.getItem("clientReportColumns");
	if (clientReportColumns) return JSON.parse(clientReportColumns);
	else return [];
}

// function getMyFilters(page = "analysis") {
// 	const filters = localStorage.getItem("filters");
// 	if (!filters) {
// 		return [];
// 	}
// 	let filters = JSON.parse(localStorage.getItem("filters"));

// 	if (page === "landingPage") {
// 		let { tenant } = userServices.getCurrentUser();
// 		if (tenant !== "BAT_STATES") {
// 			return JSON.parse(filters);
// 		}
// 		// fhide shop image filter
// 		// hide Consumer Profile section
// 		console.log({ filters });
// 		filters = filters.filter(filter => {
// 			filter._Childrens = filter?._Childrens?.filter(child => {
// 				return child?._ApiTag !== "shop_data.img_exist";
// 			});
// 			// remove Consumer_Profile filter

// 			return filter.Key !== "Consumer_Profile";
// 		});
// 		return filters;
// 	}
// 	if (filters) return JSON.parse(filters);
// 	return [];
// }

function getMyFilters(page = "analysis") {
	const stored = localStorage.getItem("filters");
	if (!stored) {
		return [];
	}

	let filters;
	try {
		filters = JSON.parse(stored);
	} catch {
		console.error("getMyFilters: failed to parse filters JSON");
		return [];
	}

	if (page === "landingPage") {
		const { tenant } = userServices.getCurrentUser();
		if (tenant !== "BAT_STATES") {
			return filters;
		}

		// For BAT_STATES specifically, filter out the image‐exist filter and the Consumer_Profile filter
		return filters
			.map(filter => {
				// copy to avoid mutating original
				const copy = { ...filter };
				if (Array.isArray(copy._Childrens)) {
					copy._Childrens = copy._Childrens.filter(child => child._ApiTag !== "shop_data.img_exist");
				}
				return copy;
			})
			.filter(filter => filter.Key !== "Consumer_Profile");
	}

	return filters;
}

function getSecDifination() {
	const secDifination = localStorage.getItem("secDifination");
	if (secDifination) return JSON.parse(secDifination);
	else return [];
}

function getUserHomeRoute() {
	const user = userServices.getCurrentUser();

	if (!user) return RoutesService.getLoginRoute();
	let { role } = user;

	return RoutesService.getRoleRoute(role);
}

function getMyCensusShopCardData() {
	const censusShopCardData = localStorage.getItem("censusShopCardData");
	if (censusShopCardData) return JSON.parse(censusShopCardData);
	else return [];
}
function getMyClientShopCardData() {
	const clientShopCardData = localStorage.getItem("clientShopCardData");
	if (clientShopCardData) return JSON.parse(clientShopCardData);
	else return [];
}
export {
	signIn,
	signOut,
	refreshAccessToken,
	isTokenValid,
	isAccessTokenValid,
	setRefreshToken,
	getRefreshToken,
	setAccessToken,
	getAccessToken,
	getUserFromToken,
	handleTokenExpiry,
	onAuthStateChange,
	getMyPermissions,
	setMyConfig,
	getMyCensusReportColumns,
	getMyClientReportColumns,
	getUserHomeRoute,
	getMyFilters,
	getMyCensusShopCardData,
	getMyClientShopCardData,
	getSecDifination,
	setMyFilters
};
